import { render } from "./CopySvgIcon.vue?vue&type=template&id=0977dfe9"
import script from "./CopySvgIcon.vue?vue&type=script&lang=js"
export * from "./CopySvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__